export default __webpack_public_path__ + "static/media/User_Manual.fd57a730.svg";